import { ActivatedRoute } from "@angular/router";
import { AfterViewChecked, ChangeDetectorRef, Component, Injector, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';

import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { AppEventNames } from 'src/app-client/_appCommon/base/Constants';
import { BroadcastManager } from 'src/app-client/_appCommon/base/BroadcastManager';
import { CRUDFormControllerBase } from 'src/app-client/_appCommon/base/CRUDFormControllerBase';
import { CaseAdditionalFilesDataService } from '../../../_dataservices/CaseAdditionalFilesDataService';
import { CaseFileDataService } from 'src/app-client/_dataservices/CaseFileDataService';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { ECOMMERCE_USER_TOKEN } from 'src/app/_appCommon/base/Constants';
import { FileAdditionalArray, FileCompositeArray, FileRadiographyArray, FileSTLArray, FileType, FileTypeArray, FileTypeLabel, FileTypeNamePath, UpdateFileDto } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { MediaDataService } from 'src/app-client/_dataservices/MediaDataService';
import { SystemServicesDataService } from 'src/app-client/_dataservices/security/SystemServicesDataService';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { SliderImagesDataService } from "src/app-client/_dataservices/SliderImagesDataService";
import { SetupDataService } from "src/app-client/_dataservices/SetupDataService";
import { Section, SmartSTLAccessoriesAndButtonsArray, SmartSTLRequestStatuses } from "src/app/_appCommon/base/AppInterfaceAndBaseClasses";
import { DentalMonitoringDataService } from '../../../_dataservices/DentalMonitoringDataService';
import { CaseStageDataService } from "src/app-client/_dataservices/CaseStageDataService";


@Component({
  selector: 'app-client-crud-casefile',
  templateUrl: './crud-casefile.component.html',
  styleUrls: ['./crud-casefile.component.css'],
  providers: [MediaDataService, CaseFileDataService, CaseAdditionalFilesDataService, SystemServicesDataService, CustomerDataService, DentalMonitoringDataService, CaseStageDataService]
})
export class CrudCaseFileComponent extends CRUDFormControllerBase<CaseFileDataService> implements AfterViewChecked
{
  @ViewChild('stepper') stepper: MatStepper;

  public additionalFilesForm: FormGroup;
  public compositeForm: FormGroup;
  public customerId: number;
  public isCaseDetail: boolean = false;
  public isCompositeActive = false;
  public photographyForm: FormGroup;
  public radiographyForm: FormGroup;
  public stlForm: FormGroup;

  // Array Files
  public fileAdditionalArray: any[];
  public fileCompositeArray: any[];
  public fileImageArray: any[];
  public fileRadiographyArray: any[];
  public fileSTLArray: any[];

  private caseAdditionalFilesResponse: any[];
  private caseFileResponse: any[];

  stlFilesUploadType: boolean = true;
  public smartSTLAccessoriesAndButtons = SmartSTLAccessoriesAndButtonsArray;
  public searchByPatientProfileId: string = "";
  public dentalMonitoringPatientInfo: any;
  
  public dentalMonitoringPatientPhase : string;
  public dentalMonitoringTreatmentContext:string;
  public dentalMonitoringInstructions:string;
  public dentalMonitoringAccessoriesAndButtons: string;

  public isPrescriptionCompleted: boolean = false; // ! IsPartialSaved
  public hasARequestSmartSTL: boolean = false;
  public requestSmartSTLStatus : string = ''; 
  public hasCaseFileUpperSTL: boolean = false;
  public hasCaseFileLowerSTL: boolean = false;
  public requestSmartSTLOrderId : number | null;
  public requestSmartSTLPatientProfileId : string;
  public requestSmartStlId: number | null;

  public sendingDentalMonitoringSmartStlRequest: boolean = false;
  public hasArcadOrderInPreviousCaseStage = false;
  SmartSTLRequestStatuses = SmartSTLRequestStatuses;

  constructor(
    activatedRoute: ActivatedRoute,
    private systemServicesDataService: SystemServicesDataService,
    private customerDataService: CustomerDataService,
    private mediaDataService: MediaDataService,
    private caseFileDataService: CaseFileDataService,
    private caseAdditionalFilesService: CaseAdditionalFilesDataService,
    private formBuilder: FormBuilder,
    private injector: Injector,
    private cdr:ChangeDetectorRef,
    private caseAdditionalDataService: CaseAdditionalFilesDataService,
    private sliderImagesDataService: SliderImagesDataService,
    private setupDataService:SetupDataService,
    private dentalMonitoringDataService : DentalMonitoringDataService,
    private caseStageDataService: CaseStageDataService
  )
  {
    super(activatedRoute, caseFileDataService);
  }

  ngAfterViewChecked()
  {
    this.cdr.detectChanges();
  }

  ngOnInit(): void
  {
    this.activatedRoute.url.subscribe(url => {
      this.isCaseDetail = url.toString().contains('detail');
    });  

    this.activatedRoute.paramMap
      .subscribe(params => 
      {
        this.getGetLastManufacturedCaseStageByCaseId(+params.get('id'));
      });

    this.isPrescriptionCompleted = false; // ! IsPartialSaved
    this.hasARequestSmartSTL = false;
    this.requestSmartSTLStatus = ''; 
    this.hasCaseFileUpperSTL = false;
    this.hasCaseFileLowerSTL = false;
    this.requestSmartSTLOrderId = null;
    this.sendingDentalMonitoringSmartStlRequest = false;
    this.hasArcadOrderInPreviousCaseStage = false;

    if (AppClientContext.Instance.setup)
      this.id = AppClientContext.Instance.setup.caseFileId;

    if (AppClientContext.Instance.customerId)
      this.customerId = AppClientContext.Instance.customerId;
    else
      this.getStartupInfo();


        
    if (AppClientContext.Instance.setup) {
      this.getCurrentSetup();
    }

    


    this.initializeForms();
    this.initializeArrays();
    this.getAllCaseFiles();
    this.getAllCaseAdditionalFiles();

    BroadcastManager.Instance.on(AppEventNames.onCompleteCase)
      .subscribe(([data]: any) =>
      {
        if (data)
          this.resetCaseFileForms();
      });


      
  }
  private initializeStepper(): void
  {
      this.activatedRoute.paramMap.subscribe(params =>
      {
        setTimeout(() =>
        {
          if (this.isCaseDetail)
          {
            let indexPrincipalStepper = 0;
            if(AppClientContext.Instance.setup.currentStep > 2)
            {
              indexPrincipalStepper = 1;
            }
            this.stepper.selectedIndex = indexPrincipalStepper;
          }
          else
          {
            this.stepper.selectedIndex = +params.get('id') - 1;
          }
        });
      });
  }
  private initializeArrays(): void
  {
    this.fileCompositeArray = JSON.parse(JSON.stringify(FileCompositeArray));
    this.fileImageArray = JSON.parse(JSON.stringify(FileTypeArray));
    this.fileRadiographyArray = JSON.parse(JSON.stringify(FileRadiographyArray));
    this.fileSTLArray = JSON.parse(JSON.stringify(FileSTLArray));

    //Archivos adicionales
    this.fileAdditionalArray = [JSON.parse(JSON.stringify(FileAdditionalArray))];
    this.fileAdditionalArray[this.fileAdditionalArray.length - 1].name = "AdditionalFile" + (this.fileAdditionalArray.length - 1).toString();
    //Archivos adicionales
  }

  private initializeForms(): void
  {
    //Archivos adicionaless
    this.additionalFilesForm = this.formBuilder.group(
      {
        AdditionalFile0: [null, ''],
        AdditionalFile1: [null, ''],
        AdditionalFile2: [null, ''],
        AdditionalFile3: [null, ''],
        AdditionalFile4: [null, ''],
        AdditionalFile5: [null, ''],
        AdditionalFile6: [null, ''],
        AdditionalFile7: [null, ''],
        AdditionalFile8: [null, ''],
        AdditionalFile9: [null, ''],
        AdditionalFile10: [null, ''],
      });

    this.photographyForm = this.formBuilder.group(
      {
        LateralExtraoral: [null, ''],
        FrontalExtraoral: [null, ''],
        SmileExtraoral: [null, ''],
        UpperOcclusal: [null, Validators.required],
        LowerOcclusal: [null, Validators.required],
        LeftLateralIntraoral: [null, Validators.required],
        FrontalIntraoral: [null, Validators.required],
        RightLateralIntraoral: [null, Validators.required],
      });

    this.compositeForm = this.formBuilder.group(
      {
        Composite: [null, Validators.required]
      });

    this.radiographyForm = this.formBuilder.group(
      {
        LateralRadiography: [null, ''],
        PanoramicRadiography: [null, ''],
        AditionalRadiography: [null, ''],
      });

    this.stlForm = this.formBuilder.group(
      {
        LowerSTL: [null, Validators.required],
        UpperSTL: [null, Validators.required],
        BiteSTL: [null, ''],
      });
  }

  private onStatusChangesFileForms(): void
  {
    this.photographyForm.statusChanges.subscribe(valid =>
    {
      BroadcastManager.Instance.broadcast(AppEventNames.onPhotographyValidity, valid == "VALID");
    });

    this.compositeForm.statusChanges.subscribe(valid =>
    {
      BroadcastManager.Instance.broadcast(AppEventNames.onCompositeValidity, valid == "VALID");
    });

    this.stlForm.statusChanges.subscribe(valid =>
    {
      BroadcastManager.Instance.broadcast(AppEventNames.onSTLValidity, valid == "VALID");
    });
  }

  private getAllCaseFiles(): void
  {
    this.getById(this.id);
  }

  //Archivos adicionales
  private getAllCaseAdditionalFiles(): void
  {
    this.caseAdditionalFilesService.getCaseAdditional(this.onGetQueryDefForCaseAdditional(this.GetCaseId))
      .subscribe((response: any) =>
      {
        this.caseAdditionalFilesResponse = response;
        this.setCaseAdditionalFiles();
      });
  }
  //Archivos adicionales
  private setCaseAdditionalFiles(): void
  {
    for (let i = 0; i < this.caseAdditionalFilesResponse.length; i++)
    {
      if (i == 0)
      {
        this.fileAdditionalArray[i].Id = 0;
        this.fileAdditionalArray[i].label = this.caseAdditionalFilesResponse[i].name.slice(this.caseAdditionalFilesResponse[i].name.indexOf("_")+1, this.caseAdditionalFilesResponse[i].name.length);
        this.fileAdditionalArray[i].name = "AdditionalFile" + i.toString();
        this.fileAdditionalArray[i].fileInfo = { name: this.caseAdditionalFilesResponse[i].name, url: this.caseAdditionalFilesResponse[i].path, blobId: this.caseAdditionalFilesResponse[i].blobId };
      }
      else
      {
        this.fileAdditionalArray.push(
          {
            Id: i,
            type: FileType.AdditionalCaseFileId,
            label: this.caseAdditionalFilesResponse[i].name.slice(this.caseAdditionalFilesResponse[i].name.indexOf("_")+1, this.caseAdditionalFilesResponse[i].name.length),
            name: "AdditionalFile" + i.toString(),
            fileInfo: { name: this.caseAdditionalFilesResponse[i].name, url: this.caseAdditionalFilesResponse[i].path, blobId: this.caseAdditionalFilesResponse[i].blobId }

          }
        );
      }
    }

    if (this.caseAdditionalFilesResponse.length != 0)
      this.addNewElementFileAdditionalArray();
  }

  //Archivos adicionales
  public onGetQueryDefForCaseAdditional(CaseId: any): UrlQueryDef
  {
    let queryDef = new UrlQueryDef();
    queryDef.addParam("caseId", CaseId);
    return queryDef;
  }
  private setImagesCaseFile(): void
  {
    if (this.caseFileResponse)
    {
      // SET COMPOSITE FILES
      for (const file of this.fileCompositeArray)
        this.setFileInfo(file);

      // SET COMPOSITE PHOTOGRAPHY FILES
      for (const file of this.fileImageArray)
        this.setFileInfo(file);

      // // // SET RADIOGRAPHY FILES
      for (const file of this.fileRadiographyArray)
        this.setFileInfo(file);

      // // SET STL FILES
      for (const file of this.fileSTLArray)
        this.setFileInfo(file);

      this.onStatusChangesFileForms();
    }
  }

  private setFileInfo(file: any)
  {
    let responsePath = this.caseFileResponse[`${FileTypeNamePath.get(file.type)}`];
    let name = FileTypeLabel.get(FileType.LateralExtraoralId);

    file.fileInfo = responsePath ? { name: name, url: responsePath } : null;
  }

  public get IsCompleteCompositePhotographyForm(): boolean
  {
    return this.compositeForm.valid || this.photographyForm.valid;
  }

  private get GetCaseFileId(): number
  {
    return AppClientContext.Instance.setup.caseFileId;
  }

  private get GetCaseId(): number
  {
    return AppClientContext.Instance.case.id;
  }
  public fileSelected(file: File, item: any, fileArrayype: string): void
  {
    this.mediaDataService.saveImage(file)
      .subscribe((response: any) =>
      {
        this.sliderImagesDataService.addImage({response,item})
        if (fileArrayype == "additionalFileAdd")
        {
          this.setFile(item.Id, fileArrayype, response);
          var body = {
            caseId: this.GetCaseId,
            blobId: response.id
          };
          this.caseAdditionalFilesService.saveCaseAdditional(body);
        }
        else
        {
          this.setFile(item.type, fileArrayype, response);
        }
        this.insertFileTypeFromMediaId(response.id, item);

        if(fileArrayype == 'stl'){
          this.getCurrentSetup();
        }

        BroadcastManager.Instance.broadcast("update-files-carrousel",false);
      },
      (fail: any) =>
      {
        this.setFile(item.type, fileArrayype, { name: null, url: null });
        this.setWarningAlert(fail.error.message);
      });
  }

  private setFile(fileType: FileType, fileArrayype: string, fileBlobData: any): void
  {
    switch(fileArrayype)
    {
      case 'imageComposite':
        this.fileImageArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'composite':
        this.fileCompositeArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'radiography':
        this.fileRadiographyArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'stl':
        this.fileSTLArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'additionalFileAdd':
        this.fileAdditionalArray.find(x => x.Id == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path, blobId: fileBlobData.id } : null;
        this.fileAdditionalArray.find(x => x.Id == fileType).label = fileBlobData.name.slice(fileBlobData.name.indexOf("_")+1, fileBlobData.name.length);
        //Agregar objetos para hacerlo dinámico
        this.addNewElementFileAdditionalArray();
        break;
      case 'additionalFileDelete':
        this.deleteAdditionalFiles(this.fileAdditionalArray[fileType].fileInfo.blobId, this.GetCaseId);
        this.fileAdditionalArray.find(x => x.Id == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path, blobId: fileBlobData.id } : null;
        //Re-Ordenar-Ids y eliminar
        if (this.fileAdditionalArray.length != 1)
        {
          this.fileAdditionalArray.splice(fileType, 1);
        }
        if (this.fileAdditionalArray.length == 9)
        {
          if ((this.fileAdditionalArray.find(x => x.fileInfo == null)) === undefined)
          {
            this.addNewElementFileAdditionalArray();
          }
        }
        for (let i = 0; i < this.fileAdditionalArray.length; i++)
        {
          this.fileAdditionalArray[i].Id = i;
          this.fileAdditionalArray[i].name = "AdditionalFile" + i.toString();
        }
        break;
    }
  }
  private addNewElementFileAdditionalArray(): void
  {
    if (this.fileAdditionalArray.length + 1 != 11)
    {
      //Agregar objetos para hacerlo dinamico
      this.fileAdditionalArray.push(JSON.parse(JSON.stringify(FileAdditionalArray)));
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].Id = this.fileAdditionalArray.length - 1;
      //Cambiar el nombre forma dinámica
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].name = "AdditionalFile" + (this.fileAdditionalArray.length - 1).toString();
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].Id = this.fileAdditionalArray.length - 1;
    }
  }
  //Archivos adicionales
  private deleteAdditionalFiles(fileBlobId: any, fileCaseId): void
  {
    var body = {
      blobId: fileBlobId,
      caseId: fileCaseId
    };
    this.caseAdditionalFilesService.deleteAdditionalFiles(body);
  }

  private insertFileTypeFromMediaId(mediaId:number, item: any): void
  {
    let fileDto: UpdateFileDto = {
      id: this.GetCaseFileId,
      fileBlobId: mediaId,
      fileType: item.type,
      setupId : AppClientContext.Instance.setup.id
    };

    this.caseFileDataService.updateFile(fileDto)
      .subscribe((response: any) =>
      {
      },
      (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  public deleteFile(item: any, fileArrayype: string)
  {
    this.sliderImagesDataService.deleteImage(item);
    let fileDto: UpdateFileDto = {
      id: this.GetCaseFileId,
      fileBlobId: null,
      fileType: item.type,
      setupId : AppClientContext.Instance.setup.id
    };

    this.caseFileDataService.updateFile(fileDto)
      .subscribe((response: any) =>
      {
        if (fileArrayype == "additionalFileDelete")
        {
          this.setFile(item.Id, fileArrayype, null);
        }
        else
        {
          this.setFile(item.type, fileArrayype, null);
        }

        if(fileArrayype == 'stl'){
          this.getCurrentSetup();
        }

        BroadcastManager.Instance.broadcast("update-files-carrousel",false);

      },
      (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  private resetCaseFileForms(): void
  {
    this.photographyForm.reset();
    this.photographyForm.reset();
    this.radiographyForm.reset();
    this.additionalFilesForm.reset();
    this.stlForm.reset();

    this.initializeArrays();
  }
  // ********************************************************************************
  // #region overrride Methods
  // ********************************************************************************

  protected onGetQueryDefForGetById(queryDef: UrlQueryDef)
  {
    queryDef.includes = "FrontalIntraoral,UpperOcclusal,LowerOcclusal,LeftLateralIntraoral,RightLateralIntraoral,FrontalExtraoral,LateralExtraoral,SmileExtraoral,Composite,PanoramicRadiography,LateralRadiography,AditionalRadiography,BiteSTL,UpperSTL,LowerSTL";

    super.onGetQueryDefForGetById(queryDef);
  }

  protected onAfterGetById(_currentEntity: any): void
  {
    this.caseFileResponse = _currentEntity;
    this.currentEntity = this.currentEntity;
    this.setImagesCaseFile();
    this.checkIsCompositeActive(_currentEntity)
    this.initializeStepper();
    super.onAfterGetById(_currentEntity);
  }
  // ********************************************************************************
  // #region Methods StartupInfo
  // ********************************************************************************
  private getStartupInfo()
  {
    this.systemServicesDataService.getStartupInfo()
      .subscribe((startupInfo) =>
      {
        this.onApplicationStartup(startupInfo);
      }, error =>
      {
        if (error.status == 401)
        {
          this.forceLogout();
        }
      });
  }

  private checkIsCompositeActive(entity)
  {
    if(entity.compositePath != null)
      {
        this.isCompositeActive = true;
      }
  }

  private onApplicationStartup(startupInfo: any)
  {
    AppClientContext.Instance.initialize(startupInfo);

    // Save a reference to the angular injector to the client context
    AppClientContext.Instance.setInjector(this.injector);

    this.getCustomerInfo();
  }

  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentUser = response.items.firstOrNull();
          if (currentUser)
          {
            AppClientContext.Instance.customerId = currentUser.id;
            this.customerId = currentUser.id;
          }
        });
    }
  }

  public forceLogout(): void
  {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');

    // Remove Token
    AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

    // Clear current user
    AppClientContext.Instance.user = null;
  }

  private getUserLoginFromCache(): boolean
  {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    return this.setSecurityToken(user);
  }

  private setSecurityToken(user: any): boolean
  {
    if (user && user.cacheToken)
    {
      // Remove Token
      AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

      // Append Token
      AppClientContext.Instance.headerValues.set(ECOMMERCE_USER_TOKEN, user.cacheToken);

      return true;
    }
    return false;
  }

  private deleteAdditionalFile(fileBlobId: any, fileCaseId): void
  {
    let body =
    {
      blobId: fileBlobId,
      caseId: fileCaseId
    };
    this.caseAdditionalDataService.deleteAdditionalFiles(body)
      .subscribe((response: any) =>
      {
        this.setInfoAlert("Archivo eliminado");
      }, (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  public updateSetupCurrentStep()
  {
    let body = 
    {
      id: AppClientContext.Instance.setup.id ,
      currentStep: 3
    }
    this.setupDataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {

    });
  }

  getCurrentSetup(){
    let queryDef = new UrlQueryDef;
    queryDef.includes = "DentalMonitoringSmartStl, CaseFile";
    this.setupDataService.getById(AppClientContext.Instance.setup.id, queryDef).subscribe((res:any)=>{
      
      this.isPrescriptionCompleted = !res.isPartialSave; // ! IsPartialSaved
      this.hasARequestSmartSTL = res.dentalMonitoringSmartStlId != null && res.usesSmartStl == true;
      this.requestSmartSTLStatus = this.hasARequestSmartSTL && res.dentalMonitoringSmartStl != null ? res.dentalMonitoringSmartStl?.status :''; 
      this.hasCaseFileUpperSTL = res.caseFile.upperSTLId != null;
      this.hasCaseFileLowerSTL = res.caseFile.lowerSTLId != null;
      this.requestSmartSTLOrderId = this.hasARequestSmartSTL && res.dentalMonitoringSmartStl != null ? res.dentalMonitoringSmartStl.externalOrderId : null;
      this.requestSmartSTLPatientProfileId = this.hasARequestSmartSTL && res.dentalMonitoringSmartStl != null ? res.dentalMonitoringSmartStl.externalPatientProfileId : null;
      this.requestSmartStlId = this.hasARequestSmartSTL && res.dentalMonitoringSmartStl != null ? res.dentalMonitoringSmartStl.id : null;

      if(this.hasARequestSmartSTL){
        BroadcastManager.Instance.broadcast(AppEventNames.onDentalMonitoringSmartSTLCreated, true);
        this.cdr.detectChanges();
      }
    })
  }

  validRequestSmartSTLForm(){
    const dMDoctorId = AppClientContext.Instance.user.dentalMonitoringExternalDoctorId;

    if(dMDoctorId == this.dentalMonitoringPatientInfo?.doctorId &&
      this.dentalMonitoringPatientInfo != null &&
      this.dentalMonitoringPatientInfo?.patientId != null &&
      this.dentalMonitoringPatientInfo?.profileId != null &&
      this.dentalMonitoringPatientPhase != null && this.dentalMonitoringPatientPhase != '' &&
      this.dentalMonitoringAccessoriesAndButtons != null && this.dentalMonitoringAccessoriesAndButtons != '')
    {
      return true;
    }

    return false;
  }

  sendDentalMonitoringSmartStlRequest(){
    let body = {
      "caseId": AppClientContext.Instance.case.id,
      "currentStage": this.dentalMonitoringPatientPhase,
      "totalStage" : this.dentalMonitoringPatientInfo.totalStage,
      "treatmentContext": this.dentalMonitoringTreatmentContext,
      "attachmentsAndButtonsHandling": this.dentalMonitoringAccessoriesAndButtons,
      "instructions": this.dentalMonitoringInstructions??"",
      "patientId": this.dentalMonitoringPatientInfo?.patientId,
      "doctorId": this.dentalMonitoringPatientInfo?.doctorId,
      "externalDoctorProfileId": this.dentalMonitoringPatientInfo?.doctorProfileId,
      "externalPatientProfileId": this.dentalMonitoringPatientInfo?.profileId,
      "externalPatientName": this.dentalMonitoringPatientInfo?.fullName,
      "section": Section.Ecommerce,
    };
    this.sendingDentalMonitoringSmartStlRequest = true;
    this.dentalMonitoringDataService.createDentalMonitoringSmartStlOrder(body).subscribe(res=>{
      if(res != 0 )
      {
        this.setSuccessAlert('La solicitud de SmartSTL ha sido enviado correctamente.');
        this.getCurrentSetup();
        this.sendingDentalMonitoringSmartStlRequest = true;
      }
      else
      {
        this.setDangerAlert('Error al enviar la solicitud de SmartSTL, intente nuevamente.');
        this.sendingDentalMonitoringSmartStlRequest = false;
      }
     
    }, err=>{
      this.setDangerAlert('Error al enviar la solicitud de SmartSTL, intente nuevamente.');
      this.sendingDentalMonitoringSmartStlRequest = false;
    })
  }

  public getDentalMonitoringPatientInfo(){
    this.dentalMonitoringDataService.getDentalMonitoringPatientInfo(this.searchByPatientProfileId).subscribe(res=>{
      if(res == null){
        this.setDangerAlert('El ID_Paciente '+ this.searchByPatientProfileId +' no existe en Dental Monitoring, favor de verificarlo');
      }
      else{
        const dMDoctorId = AppClientContext.Instance.user.dentalMonitoringExternalDoctorId;
        if(dMDoctorId == res?.doctorId){
          this.dentalMonitoringPatientInfo = res;
          this.dentalMonitoringPatientPhase = this.dentalMonitoringPatientInfo.currentStage;
        }else{
          this.setDangerAlert('“El ID_Paciente '+ this.searchByPatientProfileId +' pertenece a otro usuario, favor de verificarlo');
        }
      }
    }, err=>{
      this.setDangerAlert('Error al buscar el paciente, intente de nuevo.');
    })
  }

  public hasASTLFile(): boolean{
    let biteSTLPath = this.fileSTLArray.find(x => x.type == FileType.BiteSTLId);
    let upperSTLPath = this.fileSTLArray.find(x => x.type == FileType.UpperSTLId);
    let lowerSTLPath = this.fileSTLArray.find(x => x.type == FileType.LowerSTLId);

    if(biteSTLPath.fileInfo != null || upperSTLPath.fileInfo != null || lowerSTLPath.fileInfo != null){
      return true;
    }else{
      return false;
    }
  }

  public hasDentalMonitoringExternalDoctorinfo(): boolean{
    return AppClientContext.Instance.user.dentalMonitoringExternalDoctorId != null && AppClientContext.Instance.user.dentalMonitoringExternalDoctorProfileId != null
  }

  refreshFEDMSSTL(){
    this.cdr.detectChanges();
  }

  getGetLastManufacturedCaseStageByCaseId(caseId:number){
    if(this.isCaseDetail){
      this.caseStageDataService.getGetLastManufacturedCaseStageByCaseId(caseId)
      .subscribe(res=>
      {
        this.hasArcadOrderInPreviousCaseStage = res.arcadExternalOrderId != null;
      }, 
      err=>{
        if(this.isCaseDetail){
        
            this.setDangerAlert('Error al validar ultima etapa fabricada, intente nuevamente.');
          }
      }) 
    }
  }

  cancelDentalMonitoringSmartStlRequest(){
    let body = {
      Id: this.requestSmartStlId,
      ExternalOrderId:  this.requestSmartSTLOrderId
    };
    this.dentalMonitoringDataService.cancelDentalMonitoringSmartStlRequest(body).subscribe(res=>{
      this.setSuccessAlert("Se ha cancelado correctamente la solicitud.");
      this.getCurrentSetup();
    }, err=>{
      this.setDangerAlert(err.error.message);
    })
  }

  public disableCancelButton()
  {
    return this.requestSmartSTLStatus == SmartSTLRequestStatuses.get('En proceso de cancelación') || this.requestSmartSTLStatus == SmartSTLRequestStatuses.get('Revisión')
  }

  public get disabledDentalMonitoringPatientPhaseInput(): boolean
  {
    if(this.dentalMonitoringPatientInfo != null && this.dentalMonitoringPatientInfo != undefined)
      return false;
    return true;
  }
}
